import { Feature, LanguageConfig } from "../redux/services/config";

import { parseLanguageObject } from "./parseLanguageObject";

export const getAnalyticsFeatureName = (
  languageConfig: {
    available: LanguageConfig[];
    default: LanguageConfig;
  },
  feature?: Feature,
) => {
  if (!feature) return "";

  const popupHeaderLanguageObj = feature?.properties?.popup_header;
  const nameLanguageObj = feature?.properties?.name;

  const phResult = popupHeaderLanguageObj
    ? parseLanguageObject(popupHeaderLanguageObj, languageConfig.default.id)
    : null;
  if (phResult) return phResult;

  const nResult = nameLanguageObj
    ? parseLanguageObject(nameLanguageObj, languageConfig.default.id)
    : null;
  if (nResult) return nResult;

  return "";
};
